export default __webpack_public_path__ + "static/media/core-app-icon.3385896e.svg";